import { useAppContext } from "../components/AppContext"

export const useCurrentLocale = (): string => {
  return useAppContext().currentLocale
}